/**
 * Sync da versão de assets (sem reload — o bump em layout/theme.liquid já força cache novo).
 */
(function () {
  try {
    localStorage.setItem('andrade-asset-v', '2026090501');
  } catch (_) {}
})();
